import { CanAccess } from '@modules/common/components/CanAccess';
import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import { DuplicateDashboardDialogContent } from '@modules/dashboard/components/DuplicateDashboardDialogContent';
import { ControlPointDuplicateRounded } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { PermissionOperation, PermissionResource } from 'generated/graphql';

interface DuplicateDashboardMenuItemProps {
  closeMenu: () => void;
}

export const DuplicateDashboardMenuItem = ({
  closeMenu,
}: DuplicateDashboardMenuItemProps) => {
  const { openModal } = useMuiModalContext();

  const openDuplicateDashboardForm = () => {
    openModal({
      contentComponent: () => <DuplicateDashboardDialogContent />,
      modalProps: {
        fullWidth: true,
        maxWidth: 'md',
      },
    });
    closeMenu();
  };

  return (
    <CanAccess
      resource={PermissionResource.Artefact}
      operation={PermissionOperation.Write}
    >
      <MenuItem onClick={openDuplicateDashboardForm}>
        <ListItemIcon>
          <ControlPointDuplicateRounded fontSize="small" />
        </ListItemIcon>

        <ListItemText>Duplicate Dashboard</ListItemText>
      </MenuItem>
    </CanAccess>
  );
};
